var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card"},[_c('span',{style:({
      color: _vm.titleColor,
      'text-align': 'center',
      'font-weight': 600,
      'font-size': '17px'
    })},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('div',{staticClass:"scroll",style:({
      overflowX: _vm.model.xAxis.length > 7 ? 'auto' : 'hidden'
    })},[_c('v-chart',{key:_vm.dynamicMinWidth,style:({ minWidth: _vm.dynamicMinWidth, height: '100%' }),attrs:{"option":_vm.chartOptions}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }